import { render, staticRenderFns } from "./productDesignHistory.vue?vue&type=template&id=561b92c0&scoped=true"
import script from "./productDesignHistory.vue?vue&type=script&lang=js"
export * from "./productDesignHistory.vue?vue&type=script&lang=js"
import style0 from "./productDesignHistory.vue?vue&type=style&index=0&id=561b92c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561b92c0",
  null
  
)

export default component.exports